export default __webpack_public_path__ + "static/media/ultraserv1.356eae1b.jpg";